import { useTheme } from '@shopify/polaris-viz-core';
import { jsx } from 'react/jsx-runtime';
import { SquareColorPreview } from '../../SquareColorPreview/SquareColorPreview.js';
import { LinePreview } from '../../LinePreview/LinePreview.js';

function SeriesIcon({
  color,
  isComparison = false,
  shape = 'Bar'
}) {
  const selectedTheme = useTheme();

  switch (shape) {
    case 'Line':
      {
        const style = isComparison ? 'dotted' : 'solid';
        const lineColor = isComparison ? selectedTheme.seriesColors.comparison : color;
        return /*#__PURE__*/jsx(LinePreview, {
          color: lineColor,
          lineStyle: style
        });
      }

    case 'Bar':
    default:
      return /*#__PURE__*/jsx(SquareColorPreview, {
        color: color
      });
  }
}

export { SeriesIcon };
